export default __webpack_public_path__ + "static/media/img-0072-uk-half-face.7e36e699.png";